import { Grid, Typography } from '@mui/material';
import { SubmitButton } from '@tassat/button';
import { CurrencyField } from '@tassat/formik-input';
import { stripPrefix } from '@tassat/utility';
import { Formik } from 'formik';
import React from 'react';

import useStyles from './styles';
import { validateReclaim } from './submission';
import {
    IReclaimFormErrors,
    IReclaimFormProps,
    IReclaimFormValues,
    IReclaimFormikProps
} from './types';

const FormContents = (props: IReclaimFormProps) => {
    const classes = useStyles();
    const {
        formProps,
        errors,
        values,
        isSubmitting,
        isValid,
        setFieldValue,
        submitForm
    } = props;

    const {
        pledge,
        assetPair
    } = formProps;

    const securityObject = assetPair?.security;

    React.useEffect(() => {
        const realAssetAmount = stripPrefix(values.AssetAmount, `${securityObject?.Ticker} `);
        if (realAssetAmount === '.') {
            setFieldValue('AssetAmount', `${securityObject?.Ticker} 0.`);
        }
    }, [values.AssetAmount]);

    return (
        <form className={classes.flexColumn}>
            <Grid
                container
                direction='column'
                spacing={2}
            >
                <Grid
                    className={classes.fieldContainer}
                    item
                >
                    <Typography
                        className={classes.sectionTitle}
                        variant='h5'
                    >
                        <strong>Asset Amount</strong>
                    </Typography>
                    <CurrencyField
                        currencyDecimalPoint={6}
                        currencySymbol={securityObject?.Ticker ?? ccyObject?.Ticker}
                        errors={errors}
                        fieldSize='large'
                        label=''
                        name='AssetAmount'
                        placeholder={securityObject?.Ticker ?? ccyObject?.Ticker}
                    />
                    <Typography
                        className={classes.balanceText}
                        variant='h5'
                    >
                        {`Current Posted Amount: ${pledge.AssetAmount}`}
                    </Typography>
                </Grid>
                <Grid
                    className={classes.submitContainer}
                    container
                    direction='column'
                    item
                    justifyContent='center'
                    spacing={0}
                    xs={12}
                >
                    <SubmitButton
                        disabled={isSubmitting || !isValid}
                        onClick={submitForm}
                        text='SUBMIT'
                        type='none'
                    />
                </Grid>
            </Grid>
        </form>
    );
};

export default function ReclaimForm(props: IReclaimFormikProps) {
    const { formProps } = props;
    const {
        handleReclaim,
        assetPair,
        pledge
    } = formProps;

    const initialValues: IReclaimFormValues = { AssetAmount: '' };

    const validate = async (values: IReclaimFormValues) => {
        const errors: IReclaimFormErrors = {};

        await validateReclaim(values, {
            errors,
            pledgeAvailableAssetAmount: pledge.AssetAmount,
            assetPair
        });

        return errors;
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values: IReclaimFormValues) => {
                if (handleReclaim) {
                    await handleReclaim(values);
                }
            }}
            validate={validate}
            validateOnChange
            validateOnMount
        >
            {(formContentsProps) => (
                <FormContents
                    {...formContentsProps}
                    formProps={formProps}
                />
            )}
        </Formik>
    );
}